import React from "react";
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';

import MonthlySummaryDetails from "./MonthlySummaryDetails";
import MonthlySummaryChart from "./MonthlySummaryChart";
import { Configuration } from '../../../../configs/Configuration';

class InsightsMonthlySummary extends React.Component {
    configColors = Configuration.getColors().colors;
    render() {
        const {monthlySummaryData} = this.props;
        const itemizationDetails = monthlySummaryData.monthlySummaryDataArray[monthlySummaryData.monthlySummaryActiveIndex].itemizationDetails;
        return (
            <>
                 <div className="current-billing-cycle">
                    <Typography classes={{body1: 'current-billing-cycle-text'}}>{itemizationDetails.startDate} - {itemizationDetails.endDate}</Typography>
                </div>
                <div className="insights-ms-content">
                    <div className="ms-chart">
                        <MonthlySummaryChart configColors={this.configColors}/>
                    </div>
                    <div className="ms-details">
                        <MonthlySummaryDetails configColors={this.configColors}/>
                    </div>
                </div>
            </>
        )
    }
};

const mapStateToProps = state => {
    return{
        monthlySummaryData : state.monthlySummaryData
    }
}

export default connect(mapStateToProps)(InsightsMonthlySummary);